import * as _ from 'underscore';

import { IGetRemoteRefreshAgentsResult, IRemoteRefreshAgent } from '../../ts/ServerApi/requests/GetRemoteRefreshAgentsRequest';
import { IDataSourceDetailInfo } from '../models/IDataSourceInfo';

export interface IRemoteRefreshPropertiesEditModel {
  refreshMode: string;
  remoteAgentName: string;
}

export interface IRemoteRefreshAgentOption {
  display: string;
  name: string;
  schedulesSyncedAt?: string;   // ISO 8601 formatted string, or null
  launchesSyncClient?: boolean;
  remoteAgentTimeZone?: string; // The time zone of the Tableau Bridge client
}


export namespace ChangeDatasourceRemoteRefreshPropertiesHelper {
  export function buildRemoteAgentsList(remoteAgentResult: IGetRemoteRefreshAgentsResult, datasource?: IDataSourceDetailInfo): IRemoteRefreshAgentOption[] {
    let listContainsExistingAgent = false;

    const agentList: IRemoteRefreshAgentOption[] = _.map(remoteAgentResult.agents, (agent: IRemoteRefreshAgent) => {
      if (datasource && datasource.remoteAgentName && datasource.remoteAgentName === agent.name){
        listContainsExistingAgent = true;
      }

      return {
        display: agent.name,
        name: agent.name,
        schedulesSyncedAt: agent.schedulesSyncedAt,
        remoteAgentTimeZone: agent.remoteAgentTimeZone
      };
    });

    if (!listContainsExistingAgent && datasource && datasource.remoteAgentName) {
      agentList.unshift({
        display: datasource.remoteAgentName,
        name: datasource.remoteAgentName
      });
    }

    return agentList;
  }
}
